module.exports = "virtual-scroll {\r\n    display: block;\r\n    width: 98%;\r\n    height: 400px!important;\r\n}\r\n\r\nlist-item {\r\n    display: block;\r\n    width: 100%;\r\n    height: 30px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/sharedcomponents/messagecenter/messagelist/messagelist.component.css
// module id = ./src/app/sharedcomponents/messagecenter/messagelist/messagelist.component.css
// module chunks = main